import { useInfiniteQuery } from '@tanstack/react-query';
import { api } from '../../api';

export function useClaims<T>(key: string, refetchInterval: number) {
  const query = useInfiniteQuery({
    queryKey: [key], initialPageParam: '', refetchInterval,
    queryFn: ({ pageParam }) => api.get<{ items: T[]; nextCursor: string | null }>(`/api/redeem/claims${pageParam ? `?cursor=${encodeURIComponent(pageParam)}` : ''}`),
    getNextPageParam: (page) => page.nextCursor ?? undefined,
  });
  return { ...query, items: query.data?.pages.flatMap((page) => page.items) ?? [] };
}
